<!-- 网站首页模块导航，应该是动态的 -->
<template>
  <div class="bsk_nav_box">
    <div class="container">
      <!--logo-->
      <div class="navbar-header">
        <img src="../../common/imgs/toplogo.png">
      </div>
      <!--导航栏-->
      <div style="margin-left: 50px">
        <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                 :router="true"
                 text-color="#333333" active-text-color="#ffd04b">
          <el-menu-item index="/" route="">首页</el-menu-item>
          <el-menu-item index="/coursePage" route="">课程</el-menu-item>
          <el-menu-item index="/information">资讯</el-menu-item>
          <el-menu-item index="/teachersInfo" route="">师资</el-menu-item>
          <el-menu-item index="/quiz">问答</el-menu-item>
          <el-menu-item index="/download">下载APP</el-menu-item>
          <el-menu-item index="/introduce">关于必胜</el-menu-item>
        </el-menu>
      </div>
      <div style="margin-top: 25px;font-weight: bold;color: #333333;margin-left: 10px" @click="dayPractice">
        <a>每日一练</a>
      </div>
      <!--登录区域-->
      <div style="margin-left: auto;margin-right: 0px">
        <router-link v-if="!user.user_id || user.user_id==''" class="navbar-link button_login" to="/login">
          登录
        </router-link>
        <div class="userinfo" v-if="user.user_id">
          <el-dropdown trigger="hover">
            <div style="margin-top: 15px">
              欢迎!
              <a style="margin-right: 15px;">{{
                  user.nickname ? user.nickname : "必胜用户"
                }}</a>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <router-link class="huicolor" :to="{path: '/personal' }">个人中心
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item divided @click.native="user_logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="el-dropdown-link userinfo-inner">
                <img class="img-person" :src="user.image_url"/>
              </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index-nav',
  data() {
    return {}
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    user_logout: function () {
      this.$store.commit('user_logout')
      this.$router.push({path: '/'})
    },
    dayPractice: function () { //每日一练
      if (!this.user.user_id || this.user.user_id == '') {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push({path: '/login'})
      } else {
        // window.open("http://h5.platform.winlesson.com/static/local_html/dailyexam/index.html?user_id="+this.user.user_id);
        // window.open("http://h5.dailyexam.winlesson.com");
        window.open("https://dailyexam.winlesson.com?user_id=" + this.user.user_id);
      }
    },
    handleSelect(key, keyPath) {
    }
  }
}
</script>

<style scroll src="">
@import "../../common/style/header.css";

.nav_item {
  cursor: pointer;
  list-style-type: none;
}

.nowap {
  white-space: nowrap;
  line-height: 38px;
  font-size: 14px;
  color: #5c5c5c;
}

.load {
  /*margin-left:15px;*/
}

.userinfo {
  float: left;
  margin-top: 16px;
  margin-right: 0px;
  display: flex;
}

.mt5 {
  margin-top: 5px;
}

.bsk_nav_list {
  height: 72px;
  margin: 0;
  list-style: none;
  float: left !important;
  width: 931px;
  overflow-x: auto;
  padding-left: 20px;
}

.el-menu {
  margin-top: 6px !important;
  background-color: transparent;
}

.el-menu-item {
  padding-bottom: 64px !important;
  font-size: 16px !important;
  font-weight: bold !important;
}

.el-menu.el-menu--horizontal {
  border: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Layout/bskHeader.vue